import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=57ae070d&"
import script from "./DynamicPage.ts?vue&type=script&lang=ts&"
export * from "./DynamicPage.ts?vue&type=script&lang=ts&"
import style0 from "./DynamicPage.vue?vue&type=style&index=0&id=57ae070d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports